export default __webpack_public_path__ + "static/media/quantri.79334838.png";